<template>
  <div id="selectedScheduleTagsSlider" refs="selectedScheduleTagsSlider" :data-elheight="elementHeight" class="top-slider-filter">
    <div class="background white-background"></div>

    <draggable
      v-bind="sortDraggableOptions"
      id="selectedScheduleTagsSliderContent"
      tag="div"
      ghost-class="sortable-ghost"
      filter="._toSeeAllData"
      :preventOnFilter="true"
      :list="tags"
      :item-key="(item) => item?.value"
      :group="{ name: 'tags-shared', pull: 'clone', put: false }"
      :sort="false"
      :forceFallback="true"
      :move="handleDraggableMove"
      @end="handleDraggableEnd"
    >
      <template #item="{ element: tag, index: indx }">
        <el-tag
          :class="[ `el-tag-${'selected-schedule-tags'}`,
          {'_toSeeAllData': (tag.value === '_toSeeAllData')}]"
          data-draggable-type="tag"
          :data-draggable-value="tag.value">
          <div class="background-color" :style="{'backgroundColor': (tag.backgroundColor ? tag.backgroundColor: '')}"></div>
          <div @click="handleTagItemClick($event, tag, indx)" class="tag-val">
            <span v-if="tag.value === '_toSeeAllData'">{{tag.label}}</span>
            <span v-else-if="tag.showLabel">{{tag.showLabel}}</span>
            <span v-else>{{tag.value}}</span>
          </div>
        </el-tag>
      </template>
    </draggable>
  </div>
</template>

<script src="./selected-schedule-tags-slider.js"></script>
<style lang="scss" src="./selected-schedule-tags-slider.scss"></style>
